export enum UnprocessableEntityErrorMessageParameter {
  ComparedValue = '{{ compared_value }}',
  Email = '{{ email }}',
  Extension = '{{ extension }}',
  Extensions = '{{ extensions }}',
  FileNameMaxLength = '{{ filename_max_length }}',
  Good = '{{ good }}',
  Group = '{{ group }}',
  Id = '{{ id }}',
  Limit = '{{ limit }}',
  MaxRefundPrice = '{{ maxRefundPrice }}',
  NIP = '{{ nip }}',
  Name = '{{ name }}',
  Number = '{{ number }}',
  Order = '{{ order }}',
  Price = '{{ price }}',
  Product = '{{ product }}',
  Quantity = '{{ quantity }}',
  Size = '{{ size }}',
  Suffix = '{{ suffix }}',
  Token = '{{ token }}',
  Type = '{{ type }}',
  Types = '{{ types }}',
  Username = '{{ username }}',
}
